document.addEventListener('DOMContentLoaded', function () {
  const calculator = document.querySelector('.custom-cut-calculator');
  if (!calculator) return;

  const lengthInput = document.getElementById('cut-length');
  const widthInput = document.getElementById('cut-width');
  const panelsInput = document.getElementById('cut-panels');
  const qtyInput = document.querySelector('input[name="quantity"]');
  const addButton = document.querySelector('[type="submit"][name="add"]');

  const pricePerTenth = parseFloat(calculator.dataset.price || 0);
  const priceM2 = pricePerTenth * 10;
  const currency = calculator.dataset.currency || '€';

  function money(value) {
    return value.toFixed(2).replace('.', ',') + ' ' + currency;
  }

  function setButton(disabled) {
    if (!addButton) return;
    addButton.disabled = disabled;
  }

  function calculate() {
    const length = parseFloat(lengthInput.value) || 0;
    const width = parseFloat(widthInput.value) || 0;
    const panels = parseInt(panelsInput.value) || 1;

    let valid = true;

    const lengthError = document.getElementById('cut-length-error');
    const widthError = document.getElementById('cut-width-error');

    lengthInput.classList.remove('input-error');
    widthInput.classList.remove('input-error');
    lengthError.textContent = '';
    widthError.textContent = '';

    if (length > 7000) {
      valid = false;
      lengthInput.classList.add('input-error');
      lengthError.textContent = 'Attention!';
    }

    if (width > 2100) {
      valid = false;
      widthInput.classList.add('input-error');
      widthError.textContent = 'Attention!';
    }

    const areaOnePanel = valid ? (length * width) / 1000000 : 0;
    const realAreaTotal = areaOnePanel * panels;
    const pricePerPanel = areaOnePanel * priceM2;
    const total = pricePerPanel * panels;
    const shopifyQty = Math.ceil(realAreaTotal * 10);

    document.getElementById('cut-display-panels').textContent = panels;
    document.getElementById('cut-area').textContent = realAreaTotal.toFixed(2).replace('.', ',') + ' m²';
    document.getElementById('cut-price-panel').textContent = money(pricePerPanel);
    document.getElementById('cut-total-price').textContent = money(total);

    document.getElementById('cut-summary-size').textContent =
      valid && length && width ? length + ' × ' + width + ' mm' : '-';

    document.getElementById('cut-summary-area').textContent =
      realAreaTotal > 0 ? realAreaTotal.toFixed(2).replace('.', ',') + ' m²' : '-';

    document.getElementById('cut-summary-total').textContent =
      total > 0 ? money(total) : '-';

    if (qtyInput && shopifyQty > 0 && valid) {
      qtyInput.value = shopifyQty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.getElementById('prop-length').value = valid && length ? length + ' mm' : '';
    document.getElementById('prop-width').value = valid && width ? width + ' mm' : '';
    document.getElementById('prop-panels').value = panels + ' plaque(s)';
    document.getElementById('prop-area').value = realAreaTotal > 0 ? realAreaTotal.toFixed(2) + ' m²' : '';
    document.getElementById('prop-price-panel').value = pricePerPanel > 0 ? money(pricePerPanel) : '';
    document.getElementById('prop-total').value = total > 0 ? money(total) : '';

    setButton(realAreaTotal <= 0 || !valid);
  }

  lengthInput.addEventListener('input', calculate);
  widthInput.addEventListener('input', calculate);
  panelsInput.addEventListener('input', calculate);

  calculate();
});